export enum PlanningGroups {
    GATE = "GATE",
}

export enum ContainerPlanningTypeEnum {
    IN = 2 , 
    AF = 1
}